import { getRoot } from "mobx-state-tree";

export const supportConversationsStoreViews = self => ({
  get token() {
    return getRoot(self).authStore.token;
  }
});
